import useFetchApi, { isLoading } from 'hooks/useFetchApi/useFetchApi'
import { Dispatch, useCallback, useEffect, useMemo } from 'react'
import serviceChargeSettingAPI from 'Services/api/service-charge-setting.service'
import companyAPI from 'Services/api/company.service'
import taxService from 'Services/api/tax.service'
import { PosGlobalAction } from 'views/Sale/contexts/PosProvider'
import { VoidCompReasonModel } from 'models'
import loyaltyManagementService from 'Services/api/loyaltyManagement.service'
import { TOption } from 'components/OWForm/OWSelect'
import { taxToOption } from 'views/Products/NewProduct/hooks/useGetProductAndDependencies/useGetProductAndDependencies'
import voidCompReasonService from 'Services/api/voidCompReason.service'
import orderFulfillmentTypesService from 'Services/api/orderFulfillmentTypes.service'

export const usePosDependencies = (dispatch: Dispatch<PosGlobalAction>) => {
    const [
        serviceChargeSetting,
        fetchServiceCharge,
        isLoadingserviceChargeSetting,
    ] = useFetchApi(serviceChargeSettingAPI.getServiceChargeSetting)

    const [
        fulfillmentTypes = [],
        fetchfulfillment,
        isLoadingfulfillment,
    ] = useFetchApi(orderFulfillmentTypesService.getOrderFulfillmentTypes)

    const [taxes = [], fetchTaxes, isLoadingTax] = useFetchApi(
        taxService.getTaxes,
    )

    const [
        voidCompReasonContracts = [],
        fetchVoidCompReasons,
        isLoadingVoidComps,
    ] = useFetchApi(voidCompReasonService.getVoidCompReasons)

    const [
        pointRedemptionSetting,
        fetchPointRedemptionSetting,
        fetchPointRedemptionSettingLoading,
    ] = useFetchApi(loyaltyManagementService.getLoyalPointRedemption)

    const [
        companySetting,
        fetchcompanySetting,
        isLoadingcompanySetting,
    ] = useFetchApi(companyAPI.getCurrentCompany)

    const fetchAllDependencies = useCallback(async () => {
        await fetchServiceCharge()
        await fetchTaxes()
        await fetchfulfillment()
        await fetchcompanySetting()
        await fetchPointRedemptionSetting()
        await fetchVoidCompReasons()
        dispatch({ type: 'ON_LOADED_SERVICE_CHARGE' })
    }, [
        dispatch,
        fetchServiceCharge,
        fetchTaxes,
        fetchcompanySetting,
        fetchfulfillment,
        fetchPointRedemptionSetting,
        fetchVoidCompReasons,
    ])

    useEffect(() => {
        fetchAllDependencies()
    }, [fetchAllDependencies])

    const taxOptions: TOption[] = useMemo(() => taxes.map(taxToOption), [taxes])
    const voidReasons = useMemo(
        () =>
            voidCompReasonContracts.map<VoidCompReasonModel>((r) => {
                const result: VoidCompReasonModel = {
                    voidCompReasonID: r.voidCompReasonID,
                    name: r.name,
                    value: r.percentage,
                    isPercentage: true,
                    type: r.type,
                }
                return result
            }),
        [voidCompReasonContracts],
    )

    return {
        serviceChargeSetting,
        taxes,
        taxOptions,
        voidReasons,
        companySetting,
        fulfillmentTypes,
        loading: isLoading([
            isLoadingcompanySetting,
            isLoadingfulfillment,
            isLoadingserviceChargeSetting,
            isLoadingTax,
            fetchPointRedemptionSettingLoading,
            isLoadingVoidComps,
        ]),
        pointRedemptionSetting,
    }
}
export type TUsePosDependenciesType = ReturnType<typeof usePosDependencies>
